import { GridFilterItem, GridFilterModel } from '@mui/x-data-grid-premium'
import isEmpty from 'lodash/isEmpty'
import { SavedFilter } from '../components/SavedFilterContext'

function filterItemKey(item: GridFilterItem): string {
  return JSON.stringify({
    field: item.field,
    operator: item.operator,
    value: item.value,
  })
}

export function extractUserDefinedFilters(
  filterModel: GridFilterModel,
  savedFilter: { filters: GridFilterModel } | null | undefined
): GridFilterModel {
  if (!savedFilter) {
    return filterModel
  }

  const savedFilterItems = savedFilter.filters.items ?? []
  const savedFilterQuick = savedFilter.filters.quickFilterValues ?? []

  const savedFilterCounts = new Map<string, number>()
  for (const item of savedFilterItems) {
    const key = filterItemKey(item)
    savedFilterCounts.set(key, (savedFilterCounts.get(key) ?? 0) + 1)
  }

  // get user filters
  const userItems: GridFilterItem[] = []
  for (const item of filterModel.items ?? []) {
    const key = filterItemKey(item)
    const count = savedFilterCounts.get(key) ?? 0
    if (count > 0) {
      savedFilterCounts.set(key, count - 1)
    } else {
      userItems.push(item)
    }
  }
  const userQuick = filterModel.quickFilterValues?.filter((v) => !savedFilterQuick.includes(v)) ?? []

  return {
    ...filterModel,
    items: userItems,
    quickFilterValues: userQuick,
  }
}

/**
 * Merges a saved filter with user-defined filter model
 */
export function mergeSavedFilterWithUserFilters(
  savedFilter: Omit<SavedFilter, 'deletedAt'>,
  userDefinedFilters: GridFilterModel
): GridFilterModel {
  const mergedItems = [...savedFilter.filters.items, ...userDefinedFilters.items]

  const mergedQuick = Array.from(
    new Set([...(savedFilter.filters.quickFilterValues ?? []), ...(userDefinedFilters.quickFilterValues ?? [])])
  )

  const mergedFilterModel: GridFilterModel = {
    ...userDefinedFilters,
    items: mergedItems,
    logicOperator: savedFilter.filters.logicOperator ?? userDefinedFilters.logicOperator,
    quickFilterValues: isEmpty(mergedQuick) ? undefined : mergedQuick,
  }

  return mergedFilterModel
}
